// @flow
import ConstraintCollection from "./input-constraints/ConstraintCollection";
import StringAttributeModel from "./StringAttributeModel";
import XMLConstraint from "./input-constraints/XMLConstraint";

import { ATTRIBUTE_WIDTH } from "../../constants";

/**
 * XML attribute
 */
export default class XMLAttributeModel extends StringAttributeModel {
  /**
   */
  static isApplicableModel(contributions: Object): boolean {
    const layouthint = contributions?.layouthint;
    return (
      contributions.type === "xml" ||
      (Array.isArray(layouthint) && layouthint.includes("xml"))
    );
  }

  /**
   */
  get type(): string {
    return "xml";
  }

  /**
   * Retrieve number of rows to render
   */
  get rows(): number {
    return 10;
  }

  /**
   * Add constraints
   */
  addConstraints(): ConstraintCollection {
    const constraints = new ConstraintCollection();

    constraints.add(new XMLConstraint());

    return constraints;
  }

  /**
   */
  get readonlyWidth(): $Keys<typeof ATTRIBUTE_WIDTH> {
    return ATTRIBUTE_WIDTH.EXTRA_LARGE;
  }
}
